// extracted by mini-css-extract-plugin
module.exports = {"bb-featured-stories":"bb-featured-stories__sXBkt"};